const Canvas = {
  context: null,
  setContext: function (context) {
    this.context = context;
    return this;
  },

  beginPath: function () {
    this.context.beginPath();
    return this;
  },

  fill: function () {
    this.context.fill();
    return this;
  },

  addFilter: function (canvasWidth: number, canvasHeight: number, color: string) {
    this.context.rect(1, 1, canvasWidth, canvasHeight + 2);
    this.context.fillStyle = color;
    return this;
  },

  removeRegionFilter: function (
    positionX,
    positionY,
    canvasCropWidth,
    canvasCropHeight,
    cropBorder,
    cropPadding
  ) {
    this.context.fillStyle = cropBorder;

    this.context.fillRect(
      positionX,
      positionY,
      canvasCropWidth,
      canvasCropHeight
    );

    this.context.clearRect(
      positionX + cropPadding,
      positionY + cropPadding,
      canvasCropWidth - cropPadding * 2,
      canvasCropHeight - cropPadding * 2
    );

    return this;
  },

  clear: function (width: number, height: number) {
    this.context.clearRect(0, 0, width, height);
    return this;
  },

  drawGrid: function (
    positionX: number, positionY: number,
    cropWidth: number, cropHeight: number,
    countLine: number, lineWidth: number,
  ) {

    this.context.lineWidth = lineWidth;
    this.context.strokeStyle = "#fff";

    const canvasOffsetLineX = cropWidth / countLine;
    const canvasOffsetLineY = cropHeight / countLine;

    for (let i = 1; i < countLine; i++) {
      const verticalLine = positionX + canvasOffsetLineX * i;
      const horizontalLine = positionY + canvasOffsetLineY * i;
      this.context.moveTo(
        verticalLine,
        positionY + lineWidth
      );

      this.context.lineTo(
        verticalLine,
        positionY + cropHeight - lineWidth
      );


      this.context.moveTo(
        positionX + lineWidth,
        horizontalLine
      );


      this.context.lineTo(
        positionX + cropWidth - lineWidth,
        horizontalLine
      );
    }

    return this;
  },

  stroke: function () {
    this.context.stroke();
    return this;
  },

  toDataURL: function (format: string) {
    
    return this.context.toDataURL(format);
  },

  drawImage: function (image, offsetX, offsetY, width, height) {
    this.context.drawImage(image,
      offsetX, offsetY,
      width, height,
      0, 0,
      width, height);
    return this;
  }
}


export default Canvas;